export default class Section extends Element {

}